import React from 'react';
import { FaCog, FaFileInvoice, FaVideo, FaAtom, FaHome } from 'react-icons/fa';
import './cabinet-management.css';

const CabinetManagement = ({ 
  onPreferences, 
  onInvoices, 
  onHelp,
  onAdmin,
  onGoHome,
  showGoHome = false,
  className = "" 
}) => {
  return (
    <div className={`cabinet-management ${className}`}>
      <div className="cabinet-management-title">
        Gestion du cabinet
      </div>
      
      <div className="cabinet-management-actions">
        {showGoHome && (
          <button 
            className="cabinet-management-btn home-btn"
            onClick={onGoHome}
            title="Retour à l'accueil"
          >
            <FaHome />
            <span>Retour à l'accueil</span>
          </button>
        )}
        
        <button 
          className="cabinet-management-btn preferences-btn"
          onClick={onPreferences}
          title="Préférences"
        >
          <FaCog />
          <span>Préférences</span>
        </button>
        
        <button 
          className="cabinet-management-btn invoices-btn"
          onClick={onInvoices}
          title="Factures"
        >
          <FaFileInvoice />
          <span>Factures</span>
        </button>
        
        <button 
          className="cabinet-management-btn help-btn"
          onClick={onHelp}
          title="Aide vidéo"
        >
          <FaVideo />
          <span>Aide vidéo</span>
        </button>
        
        <button 
          className="cabinet-management-btn admin-btn"
          onClick={onAdmin}
          title="Administration"
        >
          <FaAtom />
          <span>Administration</span>
        </button>
      </div>
    </div>
  );
};

export default CabinetManagement;
